import { render } from "./InitialUwLeaderboardCard.vue?vue&type=template&id=8b8167d4&scoped=true"
import script from "./InitialUwLeaderboardCard.vue?vue&type=script&lang=js"
export * from "./InitialUwLeaderboardCard.vue?vue&type=script&lang=js"

import "./InitialUwLeaderboardCard.vue?vue&type=style&index=0&id=8b8167d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b8167d4"]])

export default __exports__